import { getComplexModules } from "src/services/complexServices"
import Constants from "src/components/Common/Constants"

const migrateSelectedComplexId = state => {
  if (
    !state ||
    state.selectedComplexId ||
    typeof state.selectComplex !== "number"
  ) {
    return state
  }

  // eslint-disable-next-line unused-imports/no-unused-vars
  const { selectComplex, ...rest } = state
  return {
    ...rest,
    selectedComplexId: state.complex?.id ?? null,
  }
}

const complexMigration = async state => {
  const migratedSelection = migrateSelectedComplexId(state)

  if (!migratedSelection?.complex?.id) {
    return migratedSelection
  }

  const remoteModules = await getComplexModules(migratedSelection.complex.id)
  if (!remoteModules?.exists) {
    return migratedSelection
  }

  return {
    ...migratedSelection,
    modules: { ...Constants.modules, ...remoteModules.data() },
  }
}

export default complexMigration
